import React, { Component, createRef } from 'react'
import { observer, inject } from 'mobx-react'
import classnames from 'classnames'

@inject('selectionStore', 'uiStore')
@observer
class PopupMenu extends Component {
  constructor (props) {
    super(props)
    this.menuRef = createRef()
    this.originalY = null
    this.originalX = null
  }

  handleClickOutside = (event) => {
    // react-select (e.g. inside CopyGeometryTooltip/MoveGeometryTooltip),
    // react-floater (used by the click-tooltip) and our own Popover
    // (components/common/Popover.jsx, e.g. the export-shape-type picker)
    // all render their content via a portal appended to document.body,
    const isReactSelectOption = !!(event.target.closest && event.target.closest('[id*="react-select"]'))
    const isFloater = !!(event.target.closest && (
      event.target.closest('.__floater__') ||
      event.target.closest('.click-tooltip') ||
      event.target.closest('.delete-prompt') ||
      event.target.closest('.color-menu') ||
      event.target.closest('.color-palette-tooltip')
    ))
    const isPopoverContent = !!(event.target.closest && event.target.closest('.popover-content'))
    const isThreeDotBtn = !!(event.target.closest && (
      event.target.closest('.three') ||
      event.target.closest('.target-group__dots') ||
      event.target.closest('#three-dots') ||
      event.target.closest('[id="three-dots"]')
    ))
    if (isReactSelectOption || isFloater || isPopoverContent || isThreeDotBtn) return

    event.stopPropagation()
    if (this.menuRef.current && !this.menuRef.current.contains(event.target) && !this.props.selectionStore.isEditing && !this.props.selectionStore.data.edit) {
      this.props.selectionStore.hidePopupMenu()
    }
  }

  componentDidMount () {
    document.addEventListener('mousedown', this.handleClickOutside)

    this.resizeObserver = new ResizeObserver(() => {
      this.adjustPosition()
    })

    if (this.menuRef.current) {
      this.resizeObserver.observe(this.menuRef.current)
    }

    const { y, x } = this.props.selectionStore.menuItem || {}
    this.originalY = y
    this.originalX = x

    setTimeout(() => this.adjustPosition(), 0)
  }

  componentDidUpdate (prevProps) {
    if (this.resizeObserver && this.menuRef.current) {
      this.resizeObserver.observe(this.menuRef.current)
    }

    const { menuItem: prevMenuItem } = prevProps.selectionStore || {}
    const { menuItem: currentMenuItem } = this.props.selectionStore || {}

    if (prevMenuItem !== currentMenuItem) {
      const { y, x } = this.props.selectionStore.menuItem || {}
      this.originalY = y
      this.originalX = x
    }

    if (prevProps.content !== this.props.content) {
      setTimeout(() => this.adjustPosition(), 0)
    } else {
      this.adjustPosition()
    }
  }

  componentWillUnmount () {
    document.removeEventListener('mousedown', this.handleClickOutside)

    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
  }

  adjustPosition () {
    const { selectionStore } = this.props
    const { visible } = selectionStore.menuItem || {}

    if (!visible || !this.menuRef.current) return

    const clickY = this.originalY
    const clickX = this.originalX

    const { y: currentY, x: currentX } = selectionStore.menuItem || {}

    const popupRect = this.menuRef.current.getBoundingClientRect()
    const windowHeight = window.innerHeight
    const windowWidth = window.innerWidth

    let newY = clickY
    let newX = clickX

    if (clickY + popupRect.height > windowHeight) {
      newY = clickY - popupRect.height

      if (newY < 0) {
        newY = 5
      }
    }

    if (clickX + popupRect.width > windowWidth) {
      newX = Math.max(windowWidth - popupRect.width - 5, 5)
    }

    if (newY !== currentY || newX !== currentX) {
      selectionStore.updatePopupMenuPosition(newY, newX)
    }
  }

  render () {
    const { selectionStore, content } = this.props
    const { visible, x, y } = selectionStore.menuItem || {}

    if (!visible) {
      return null
    }

    return (
      <div
        ref={this.menuRef} className={classnames({
          tools: true,
          'sub-tools': true,
          loading: this.props.uiStore.processing,
          'popup-menu': true
        })} style={{ top: y, left: x }}
      >
        {content}
      </div>
    )
  }
}

export default PopupMenu
